import React, { FC } from 'react';
import { DraftFilterType } from 'components/DraftCollection';
import { DeviceDraftTile } from './molecules/DeviceDraftTile';
import { SetDraftTile } from './molecules/SetDraftTile';

interface DraftTileProps {
  draftFilter: DraftFilterType;
  itemsOnPage: string[];
}

export const DraftTile: FC<DraftTileProps> = ({ draftFilter, itemsOnPage }) => {
  return (
    <>
      {itemsOnPage.map(id =>
        draftFilter === DraftFilterType.set ? (
          <SetDraftTile key={id} code={id} />
        ) : (
          <DeviceDraftTile key={id} id={id} />
        ),
      )}
    </>
  );
};
